<template>
	<div>
		<section class="course-desc bg-light py-5">
			<div class="container" style="overflow: hidden; zoom: 1;margin-top: 10px;margin-bottom: 20px;">
				<img alt="" style="float: left; width: 562px; margin-right: 45px;margin-bottom: 20px; margin-top: 15px;" src="../../../assets/img/young_program_1.png">
				<img alt="" style="float: left; width: 562px; margin-bottom: 20px; margin-top: 15px;" src="../../../assets/img/young_program_2.png">
				<img alt="" style="float: left; width: 562px; margin-right: 45px;" src="../../../assets/img/young_program_3.png">
				<img alt="" style="float: left; width: 562px;" src="../../../assets/img/young_program_4.png">
				<div class="clearfix"></div>
			</div>
		</section>
		<section class="course-desc py-5">
			<div class="container py-md-3">
				<h3 class="heading mb-4 pb-2 pt-1">全国青少年编程能力等级考试</h3>
				<h4 class="heading2 mb-1">“PAAT全国青少年编程能力等级考试”为全国高等学校计算机教育研究会与各合作学术团体联合举办，面向全国学习计算机编程技术的青少年举办的考试。考试的目的是为了引导我国青少年计算机编程教育培训科学化、规范化，尽快适应时代变化，满足社会需求。全国青少年编程能力等级考试考查青少年编程能力、应用能力、创新能力。图形化编程、Python编程考试依据的标准是，由全国高等学校计算机教育研究会、全国高等学校计算机基础教育研究会、中国软件行业协会、中国青少年宫协会联合发布的团体标准。</h4>
				<div class="row process-grids mb-3">
					<div class="col-lg-12 col-md-12">
						<div class="mt-3 mb-5" style="text-align: center;">
							<img src="../../../assets/img/c1.jpg" alt="" class="img-fluid" style="width: 50%;" />
							<img src="../../../assets/img/c2.jpg" alt="" class="img-fluid" style="width: 50%;" />
						</div>
						<div class="mt-3 mb-3" style="text-align: center;">
							<img src="../../../assets/img/c3.jpg" alt="" class="img-fluid mr-4" style="width: 48%;" />
							<img src="../../../assets/img/c4.jpg" alt="" class="img-fluid" style="width: 48%;" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'CppContent',
		methods: {},
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/IndexContent.scss';
</style>